import React from "react";
import Client from "chekin-sdk";
import { Reservation } from "chekin-sdk/lib/types/chekin-types";
import { useQuery } from 'react-query'
import { useAsync } from 'react-async-hook'

const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiYmUxOGQyZDdlNTA5NGZhYjljYWZmNjRmMmNkNWUzNjUiLCJhY2NvdW50X2lkIjoiN2U2NTAwNjExMjc3NGE2NmJhZmVlMTIyYThjODFmZjkiLCJ1c2VybmFtZSI6Im1hcmlhQGNoZWtpbi5jb20iLCJleHAiOjE2NTUyNDA4NjQsIm93bmVyX2lkIjpudWxsLCJyb2xlIjoiT3duZXIiLCJvcmlnX2lhdCI6MTY1NTIzNzI1OSwicmVzZXJ2YXRpb25faWQiOiI5MGE4MDQyOTg0N2I0MGFiYjI1MjEwMDUwOTU2NzRjNiIsImlzX29jcl9lbmFibGUiOmZhbHNlLCJmYWNlX2V4dCI6ZmFsc2UsIm9jcl92aXoiOmZhbHNlLCJvY3JfYmFyY29kZXMiOmZhbHNlfQ.vGkMVExNVo9WLz9HjcGCrcfpHbMgMiTOi3RgfSWz7Ac"

type ContextProps = {
  data: any;
};



const ReservationContext = React.createContext<ContextProps>({
  data: {},
  // isLoading: false,
  // isError: false,
  // setReservation: () => {},
  // refreshReservation: (beforeUpdateCallback?: () => void) =>
  //   Promise.resolve({error: null, data: null}),
  // patchReservation: () => Promise.resolve({error: null, data: null}),
});




function ReservationProvider(props?:any) {
  const api = new Client.Client({clientId:token});
  
  const {getReservation} = api.reservation;
  const data = useAsync(getReservation, ['90a80429847b40abb2521005095674c6']);
  const reservation = React.useMemo(()=> data?.result?.data || {}, [data]);
  return (
    <ReservationContext.Provider
      value={{
        data:reservation
      }}
      {...props}
    />
  );
}

function useReservation() {
  const context = React.useContext(ReservationContext);
  if (context === undefined) {
    throw new Error('useReservation must be used within a ReservationProvider');
  }
  return context;
}

export {ReservationContext, ReservationProvider, useReservation};